import React from 'react';

interface UserAvatarProps {
  user?: {
    firstName?: string;
    lastName?: string;
    profilePicture?: string | null;
  } | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 'md', className = '' }) => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-16 h-16 text-2xl',
    xl: 'w-32 h-32 text-4xl'
  };

  const getInitials = () => {
    if (!user) return '?';
    const first = user.firstName?.[0] || '';
    const last = user.lastName?.[0] || '';
    return (first + last).toUpperCase() || '?';
  };

  if (user?.profilePicture) {
    return (
      <img
        src={`${API_URL}${user.profilePicture}`}
        alt={`${user.firstName} ${user.lastName}`}
        className={`${sizeClasses[size]} rounded-full object-cover border-2 border-gray-300 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-semibold border-2 border-gray-400 ${className}`}
    >
      {getInitials()}
    </div>
  );
};

export default UserAvatar;
